import React, { Fragment } from 'react';
import { Table, Button, Dropdown, Icon, Menu, Divider, Modal, Badge } from 'antd';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import { formatPrice, formatTimestamp } from 'utils/utils.js';
import { commodityStatusMapArr } from 'utils/enum/state-enum.js';
import styles from './Table.less';

@connect(({ merchantCommodity, loading }) => ({
  loading:
    loading.effects['merchantCommodity/fetchDataSource'] ||
    loading.effects['merchantCommodity/delete'],
  dataSource: merchantCommodity.dataSource,
  pagination: merchantCommodity.pagination,
  searchParams: merchantCommodity.searchParams,
}))
export default class Record extends React.Component {
  handleAdd = () => {
    this.props.dispatch(routerRedux.push(`/merchant/commodity/saveOrUpdate?type=add`));
  };

  handleQuery = rowData => {
    this.props.dispatch(
      routerRedux.push(`/merchant/commodity/query?type=query&id=${rowData.commodityId}`)
    );
  };

  handleRelate = rowData => {
    this.props.dispatch(
      routerRedux.push(`/merchant/commodity/relate?id=${rowData.commodityId}&name=${rowData.name}`)
    );
  };

  handleEdit = rowData => {
    this.props.dispatch(
      routerRedux.push(`/merchant/commodity/saveOrUpdate?type=edit&id=${rowData.commodityId}`)
    );
  };

  handleDelete = rowData => {
    const { dispatch } = this.props;

    Modal.confirm({
      title: '是否确认删除此商品，删除该商品后，在商品管理列表中将无此商品？',
      onOk: () => {
        dispatch({
          type: 'merchantCommodity/delete',
          id: rowData.commodityId,
        }).then(() => {
          dispatch({ type: 'merchantCommodity/toggleRefreshFlag' });
        });
      },
    });
  };

  handleExport = rowData => {
    this.props.dispatch({
      type: 'merchantCommodity/fetchRelateSchools',
      rowData,
    });
  };

  handleTableChange(pagination, filters, sorter) {
    this.props.dispatch({
      type: 'merchantCommodity/savePagination',
      pagination: {
        current: pagination.current,
        pageSize: pagination.pageSize,
      },
    });

    if (this.props.onChange) {
      this.props.onChange(pagination, filters, sorter);
    }
  }

  render() {
    const columns = [
      {
        title: '商品号',
        dataIndex: 'commodityId',
      },
      {
        title: '商品名称',
        dataIndex: 'name',
      },
      {
        title: '商户名称',
        dataIndex: 'merchantName',
      },
      {
        title: '价格（元）',
        dataIndex: 'minPrice',
        render: (val, rowData) => {
          if (rowData.minPrice === rowData.maxPrice) {
            return formatPrice(val);
          }

          return `${formatPrice(rowData.minPrice)}-${formatPrice(rowData.maxPrice)}`;
        },
      },
      {
        title: '状态',
        dataIndex: 'status',
        render: val => {
          const status = commodityStatusMapArr.find(q => q.key === val);
          return <Badge status={status.badge} text={status.value} />;
        },
      },
      {
        title: '更新时间',
        dataIndex: 'gmtModify',
        render: val => formatTimestamp(val),
      },
      {
        title: '操作',
        render: rowData => {
          const menu = (
            <Menu>
              {rowData.status === 'NOT_SHELF' && (
                <Menu.Item onClick={this.handleEdit.bind(this, rowData)}>编辑</Menu.Item>
              )}
              {rowData.status === 'NOT_SHELF' && (
                <Menu.Item onClick={this.handleDelete.bind(this, rowData)}>删除</Menu.Item>
              )}
              <Menu.Item onClick={this.handleExport.bind(this, rowData)}>导出明细</Menu.Item>
            </Menu>
          );

          return (
            <Fragment>
              <a onClick={this.handleQuery.bind(this, rowData)}>查看</a>
              <Divider type="vertical" />
              <a onClick={this.handleRelate.bind(this, rowData)}>上下架</a>
              <Divider type="vertical" />
              <Dropdown overlay={menu}>
                <a>
                  更多<Icon type="down" />
                </a>
              </Dropdown>
            </Fragment>
          );
        },
      },
    ];

    const pagination = {
      showQuickJumper: true,
      showSizeChanger: true,
      current: this.props.pagination.current,
      total: this.props.pagination.total,
    };

    return (
      <div className={styles.root}>
        <div className="table-operation-buttons-wraps">
          <Button type="primary" icon="plus" onClick={this.handleAdd.bind(this)}>
            新增
          </Button>
        </div>
        <Table
          loading={this.props.loading}
          rowKey="commodityId"
          dataSource={this.props.dataSource}
          columns={columns}
          pagination={pagination}
          onChange={this.handleTableChange.bind(this)}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Commodity/Table.js